import { useSearchParams } from 'react-router-dom';
import { APPLY_REGISTER_ID } from '@/modules/common/constants/search-params.ts';
import { useRegisterQuery } from '@/modules/common/queries/registers.ts';

export const useGetApplyRegisterName = () => {
  const [params] = useSearchParams();

  const applyRegisterIdSearchParam = params.get(APPLY_REGISTER_ID);

  const applyRegisterId =
    applyRegisterIdSearchParam && !isNaN(+applyRegisterIdSearchParam)
      ? +applyRegisterIdSearchParam
      : 0;

  const {
    data: applyRegisterData,
    isLoading: isApplyRegisterLoading,
    isError,
  } = useRegisterQuery(applyRegisterId, !applyRegisterId);

  return {
    name: applyRegisterData?.data?.name || null,
    type: applyRegisterData?.data?.type || null,
    isLoading: isApplyRegisterLoading && !!applyRegisterId,
    isError,
  };
};
